// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__sot6G","container":"styles_container__3ePlb","title":"styles_title__1Nxvg","wrapper":"styles_wrapper___oI6_","answer":"styles_answer__3YZXw"};